"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../styled"));
var paragraph_1 = __importDefault(require("../atoms/paragraph"));
var StyledText = styled_1.default(paragraph_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var useStyledTextIfAppropiate = function (children, useParagraph) {
    var Wrapper = useParagraph ? StyledText : React.Fragment;
    return React.createElement(Wrapper, null, children);
};
var FreeText = function (_a) {
    var text = _a.text, children = _a.children, _b = _a.useParagraph, useParagraph = _b === void 0 ? false : _b;
    if (children) {
        return useStyledTextIfAppropiate(children, useParagraph);
    }
    if (typeof text === 'string') {
        return useStyledTextIfAppropiate(text, useParagraph);
    }
    if (text) {
        return React.createElement(React.Fragment, null, text);
    }
    return null;
};
exports.default = FreeText;
var templateObject_1;
//# sourceMappingURL=free-text.js.map